import { render, staticRenderFns } from "./CompletedStepsMessage.vue?vue&type=template&id=5ffb144d&scoped=true"
import script from "./CompletedStepsMessage.vue?vue&type=script&lang=js"
export * from "./CompletedStepsMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb144d",
  null
  
)

export default component.exports